import React, { useState, useEffect } from "react";
import { useAuth } from "../../../usercontext";
import StudentCollegeList from "./CollegeList";
import STopMenu from "../../student/topmenu/topmenu";
import S12TopMenu from "../topmenu/topmenu";
import S911TopMenu from "../../student911/topmenu/topmenu";
import PageNotes from '../../pages/common/pagenotesnew'

export default function StudentCollegeListIndex() {
	const { profile } = useAuth()
	const slug = profile.id
	const isStudent12 = profile?.role === 'Student12'
	const isStudent = profile?.role === 'Student'
	const isStudent911 = profile?.role === 'Student911'
	return (
		<>
			{isStudent && <STopMenu slug={slug} activeMenu="StudentCollegeList" />}
			{isStudent12 && <S12TopMenu slug={slug} activeMenu="StudentCollegeList" />}
			{isStudent911 && <S911TopMenu slug={slug} activeMenu="StudentCollegeList" />}
			<PageNotes type={'Student'} studentId={slug} />
			<StudentCollegeList />
		</>
	)
}
